import type { ClinicalDocumentType } from '@/entities/clinicalDocument/types'
import {
  resolveSignedDocumentTypeForClinicalEditor,
  type PrescriptionSignatureKind,
} from './digitalSignatureDocumentType'

export const SIGN_ON_SAVE_KEYS = [
  'prescription_controlled',
  'prescription_antimicrobial',
  'prescription_simple',
  'medical_certificate',
  'exam_request',
  'other',
] as const

export type SignOnSaveKey = (typeof SIGN_ON_SAVE_KEYS)[number]
export type SignOnSavePreferences = Record<SignOnSaveKey, boolean>

/** SPREF-02: salvar apenas abre a folha; a assinatura depende da confirmação do médico. */
export const DEFAULT_SIGN_ON_SAVE: Readonly<SignOnSavePreferences> = Object.freeze({
  prescription_controlled: true,
  prescription_antimicrobial: true,
  prescription_simple: true,
  medical_certificate: true,
  exam_request: false,
  other: false,
})

export function resolveSignOnSaveKey(
  clinicalType: ClinicalDocumentType,
  prescriptionKind: PrescriptionSignatureKind | null = null,
): SignOnSaveKey {
  const signedType = resolveSignedDocumentTypeForClinicalEditor(clinicalType, prescriptionKind)
  return signedType === 'medical_report' || signedType === 'medical_opinion' ? 'other' : signedType
}

/** Lê somente booleanos conhecidos; dados ausentes ou inválidos usam o padrão daquele tipo. */
export function parseSignOnSavePrefs(value: unknown): SignOnSavePreferences {
  const preferences = { ...DEFAULT_SIGN_ON_SAVE }
  if (!value || typeof value !== 'object' || Array.isArray(value)) return preferences
  const source = value as Record<string, unknown>
  for (const key of SIGN_ON_SAVE_KEYS) {
    if (typeof source[key] === 'boolean') preferences[key] = source[key]
  }
  return preferences
}
